import AlertPayPeriodAmountChanged from './AlertPayPeriodAmountChanged';

export default AlertPayPeriodAmountChanged;
